/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Fact_ToolsInputs */

const en_mk_sol_fact_tools = /** @type {(inputs: Mk_Sol_Fact_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools they use today`)
};

const id_mk_sol_fact_tools = /** @type {(inputs: Mk_Sol_Fact_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alat yang dipakai sekarang`)
};

/**
* | output |
* | --- |
* | "Tools they use today" |
*
* @param {Mk_Sol_Fact_ToolsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_fact_tools = /** @type {((inputs?: Mk_Sol_Fact_ToolsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Fact_ToolsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_fact_tools(inputs)
	return en_mk_sol_fact_tools(inputs)
});